import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import moment from "moment";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { withStyles } from "@mui/styles";
import CustomizedTextField from "../../components/Input/CustomizedTextField";
import "../../utils.css";
import "./EquipmentEPI.css";
import Button from "@mui/material/Button";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import {
    generateControlForm,
    deleteEquipment,
    saveEquipmentFields,
    updateFilteredList,
} from "../../redux/epi/epiActions";
import { openEquipmentEPIForm } from "../../redux/epi/epiEditionActions";
import { throwWarning, throwInfo } from "../../lib/error_helper";

const styles = {
    appBar: {
        position: "relative",
    },
    flex: {
        flex: 1,
    },
};

class EquipmentEPI extends Component {
    constructor(props) {
        super(props);

        if (!this.props.equipmentEPI) {
            this.props.history.push("/epis");
        }

        this.state = {
            brand: this.props.equipmentEPI.brand,
            model: this.props.equipmentEPI.model,
            serial_number: this.props.equipmentEPI.serial_number,
        };
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (!nextProps.equipmentEPI || !this.props.equipmentEPI) return false;

        if (
            ((this.props.equipmentEPI.brand_required ? nextState.brand : true) &&
                (this.props.equipmentEPI.model_required ? nextState.model : true) &&
                (this.props.equipmentEPI.serial_number_required ? nextState.serial_number : true)) !=
            ((this.props.equipmentEPI.brand_required ? this.state.brand : true) &&
                (this.props.equipmentEPI.model_required ? this.state.model : true) &&
                (this.props.equipmentEPI.serial_number_required ? this.state.serial_number : true))
        ) {
            return true;
        }

        if (
            nextState.brand !== this.state.brand ||
            nextState.model !== this.state.model ||
            nextState.serial_number !== this.state.serial_number
        )
            return true;

        return nextProps.equipmentEPI !== this.props.equipmentEPI;
    }

    handleClose = () => {
        this.props.changeProfileModalState(false);
    };

    openEquipmentEPIForm() {
        if (
            (this.props.equipmentEPI.brand_required && !this.props.equipmentEPI.brand) ||
            (this.props.equipmentEPI.model_required && !this.props.equipmentEPI.model) ||
            (this.props.equipmentEPI.serial_number_required && !this.props.equipmentEPI.serial_number)
        ) {
            this.props.throwWarning({
                title: "Veuillez renseigner tous les champs obligatoires avant de remplir le formulaire.",
            });
            return;
        }
        this.props.generateControlForm(this.props.equipmentEPI, this.props.activeUser, () => {
            this.props.openEquipmentEPIForm(this.props.history);
        });
    }

    askUserDelete() {
        this.props.throwInfo({
            title:
                "Le modèle, la marque et le numéro de série de l'équipement ne sont pas renseignés. " +
                "Il peut donc être supprimé. Êtes-vous sûr(e) de vouloir le supprimer ?",
            dismissAfter: 0,
            forceDismissible: true,
            buttons: [
                {
                    name: "Oui",
                    primary: true,
                    onClick: () => {
                        this.deleteEquipment();
                    },
                },
                { name: "Non", primary: false, onClick: () => {} },
            ],
        });
    }

    deleteEquipment() {
        this.props.deleteEquipment(this.props.equipmentEPI.id, this.props.activeUser, () => {
            this.props.history.push("/epis");
        });
    }

    updateBrand(brand) {
        this.setState({ brand: brand });
    }

    updateModel(model) {
        this.setState({ model: model });
    }

    updateSerialNumber(serial_number) {
        this.setState({ serial_number: serial_number });
    }

    askUser() {
        this.props.throwInfo({
            title: "Les champs renseignés ne seront plus modifiables après validation. Voulez-vous les sauvegarder définitivement ?",
            dismissAfter: 0,
            forceDismissible: true,
            buttons: [
                {
                    name: "Oui",
                    primary: true,
                    onClick: () => {
                        this.validateRequiredField();
                    },
                },
                { name: "Non", primary: false, onClick: () => {} },
            ],
        });
    }

    validateRequiredField() {
        let fields = {};
        let emptyRequiredFiled = false;
        let equipmentEPI = this.props.equipmentEPI;

        if (!equipmentEPI.brand) {
            if (equipmentEPI.brand_required && !this.state.brand) {
                emptyRequiredFiled = true;
            }
            fields.brand = this.state.brand;
        }

        if (!equipmentEPI.model) {
            if (equipmentEPI.model_required && !this.state.model) {
                emptyRequiredFiled = true;
            }
            fields.model = this.state.model;
        }

        if (!equipmentEPI.serial_number) {
            if (equipmentEPI.serial_number_required && !this.state.serial_number) {
                emptyRequiredFiled = true;
            }
            fields.serial_number = this.state.serial_number;
        }

        if (emptyRequiredFiled) {
            this.props.throwWarning({
                title: "Tous les champs obligatoires doivent être renseignés.",
            });
            return;
        }

        this.props.saveEquipmentFields(equipmentEPI.id, fields, this.props.activeUser, () => {
            let updatedFilteredList = this.props.equipmentsEPI;
            let equipmentIndex = updatedFilteredList.findIndex((e) => e.id === equipmentEPI.id);
            updatedFilteredList[equipmentIndex].brand = this.state.brand;
            updatedFilteredList[equipmentIndex].model = this.state.model;
            updatedFilteredList[equipmentIndex].serial_number = this.state.serial_number;
            this.props.updateFilteredList(updatedFilteredList);
        });
    }

    render() {
        if (!this.props.equipmentEPI) return <div></div>;

        let equipmentEPI = this.props.equipmentEPI;

        let canDelete = true;
        if (
            equipmentEPI.brand ||
            equipmentEPI.model ||
            equipmentEPI.serial_number ||
            equipmentEPI.number_forms > 0 ||
            equipmentEPI.equipment_id.is_obligatory
        ) {
            canDelete = false;
        }

        let allRequiredFieldFilled = true;
        if (
            (!this.state.brand && equipmentEPI.brand_required) ||
            (!this.state.model && equipmentEPI.model_required) ||
            (!this.state.serial_number && equipmentEPI.serial_number_required)
        ) {
            allRequiredFieldFilled = false;
        }

        let missingRequiredField = false;
        if (
            (!equipmentEPI.brand && equipmentEPI.brand_required) ||
            (!equipmentEPI.model && equipmentEPI.model_required) ||
            (!equipmentEPI.serial_number && equipmentEPI.serial_number_required)
        ) {
            missingRequiredField = true;
        }

        return (
            <div className="div-container">
                <Card className="col-lg-12 col-md-12 col-sm-12 col-12 card card-margin-top without-side-padding">
                    <CardContent className="without-side-padding">
                        <div className="row col-lg-12 col-md-12 col-sm-12 col-12">
                            <div className="left col-auto mb-3">
                                <div className="row">
                                    {equipmentEPI.equipment_id.survey_id && equipmentEPI.state !== "draft" ? (
                                        <div className="col-auto mr-1 mt-1">
                                            <Button
                                                style={{ boxShadow: "none" }}
                                                variant="contained"
                                                endIcon={<EditIcon />}
                                                onClick={this.openEquipmentEPIForm.bind(this)}
                                            >
                                                Remplir formulaire
                                            </Button>
                                        </div>
                                    ) : null}
                                    {equipmentEPI.emp_id.id == this.props.activeUser.emp_id &&
                                    canDelete &&
                                    !equipmentEPI.equipment_id.agency_equipment ? (
                                        <div className="col-auto mr-1 mt-1">
                                            <Button
                                                style={{ boxShadow: "none" }}
                                                variant="contained"
                                                endIcon={<DeleteIcon />}
                                                onClick={this.askUserDelete.bind(this)}
                                            >
                                                Supprimer équipement
                                            </Button>
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="ms-auto col-auto mb-3 mt-1">
                                <Typography variant="h6">
                                    {this.props.index + "/" + this.props.equipmentsEPICount}
                                </Typography>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                                <Typography variant="h6">Informations principales</Typography>
                                <CustomizedTextField
                                    value={
                                        equipmentEPI.equipment_id.agency_equipment | !equipmentEPI.emp_id.id
                                            ? equipmentEPI.company_id.name
                                            : equipmentEPI.emp_id.id
                                              ? equipmentEPI.emp_id.first_name + " " + equipmentEPI.emp_id.last_name
                                              : ""
                                    }
                                    id="AffectedTo"
                                    label={"Affecté à"}
                                    className="full_size light-disabled control-margin-top"
                                />
                                <CustomizedTextField
                                    value={
                                        equipmentEPI.equipment_id.name +
                                        (equipmentEPI.equipment_id.agency_equipment ? " (commun)" : "")
                                    }
                                    id="Category"
                                    label={"Catégorie"}
                                    className="full_size light-disabled control-margin-top"
                                />
                                <CustomizedTextField
                                    defaultValue={equipmentEPI.brand}
                                    id="brand"
                                    label={"Marque"}
                                    className={
                                        "full_size control-margin-top" +
                                        (!missingRequiredField || equipmentEPI.brand ? " light-disabled" : "")
                                    }
                                    helperText={
                                        !equipmentEPI.brand && equipmentEPI.brand_required
                                            ? "Veuillez renseigner ce champ"
                                            : ""
                                    }
                                    onChange={(e) => {
                                        this.updateBrand(e.target.value);
                                    }}
                                    error={!this.state.brand && equipmentEPI.brand_required}
                                />
                                <CustomizedTextField
                                    defaultValue={equipmentEPI.model}
                                    id="model"
                                    label={"Modèle"}
                                    className={
                                        "full_size control-margin-top" +
                                        (!missingRequiredField || equipmentEPI.model ? " light-disabled" : "")
                                    }
                                    helperText={
                                        !equipmentEPI.model && equipmentEPI.model_required
                                            ? "Veuillez renseigner ce champ"
                                            : ""
                                    }
                                    onChange={(e) => {
                                        this.updateModel(e.target.value);
                                    }}
                                    error={!this.state.model && equipmentEPI.model_required}
                                />
                                <CustomizedTextField
                                    defaultValue={equipmentEPI.serial_number}
                                    id="serial_number"
                                    label={"Numéro de série"}
                                    className={
                                        "full_size control-margin-top" +
                                        (!missingRequiredField || equipmentEPI.serial_number ? " light-disabled" : "")
                                    }
                                    helperText={
                                        !equipmentEPI.serial_number && equipmentEPI.serial_number_required
                                            ? "Veuillez renseigner ce champ"
                                            : ""
                                    }
                                    onChange={(e) => {
                                        this.updateSerialNumber(e.target.value);
                                    }}
                                    error={!this.state.serial_number && equipmentEPI.serial_number_required}
                                />
                                <CustomizedTextField
                                    value={
                                        equipmentEPI.state == "operational"
                                            ? "Opérationel"
                                            : equipmentEPI.state == "to_repair"
                                              ? "À réparer"
                                              : equipmentEPI.state == "obsolete"
                                                ? "Obsolète"
                                                : ""
                                    }
                                    id="state"
                                    label={"Statut"}
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                            {missingRequiredField ? (
                                <div className="ms-auto col-auto mt-3">
                                    <Button
                                        style={{ boxShadow: "none" }}
                                        variant="contained"
                                        endIcon={<SaveIcon />}
                                        onClick={this.askUser.bind(this)}
                                        disabled={!allRequiredFieldFilled}
                                    >
                                        Sauvegarder
                                    </Button>
                                </div>
                            ) : null}
                            <div className="fieldset-margin-top col-lg-12 col-md-12 col-sm-12 col-12">
                                <Typography variant="h6">Dates clés</Typography>
                                <CustomizedTextField
                                    value={moment(equipmentEPI.commissioning_date).format("DD/MM/YYYY")}
                                    id="commissioning_date"
                                    label={"Date de mise en service"}
                                    className="full_size light-disabled control-margin-top"
                                />
                                <CustomizedTextField
                                    value={moment(equipmentEPI.last_check_date).format("DD/MM/YYYY")}
                                    id="last_check_date"
                                    label={"Date de dernier contrôle"}
                                    className="full_size light-disabled control-margin-top"
                                />
                                <CustomizedTextField
                                    value={moment(equipmentEPI.validity_end_date).format("DD/MM/YYYY")}
                                    id="validity_end_date"
                                    label={"Date fin de validité"}
                                    className="full_size light-disabled control-margin-top"
                                />
                            </div>
                        </div>
                    </CardContent>
                </Card>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        equipmentsEPI: state.equipmentsEPI.filteredEquipmentsEPI,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        generateControlForm: (equipmentEPI, user, onSuccess) =>
            dispatch(generateControlForm(equipmentEPI, user, onSuccess)),
        openEquipmentEPIForm: (history) => dispatch(openEquipmentEPIForm(history)),
        deleteEquipment: (equipmentId, user, onSuccess) => dispatch(deleteEquipment(equipmentId, user, onSuccess)),
        throwWarning: (warnObj) => dispatch(throwWarning(warnObj)),
        throwInfo: (infoObj) => dispatch(throwInfo(infoObj)),
        saveEquipmentFields: (equipment_id, fields, user, onSuccess) =>
            dispatch(saveEquipmentFields(equipment_id, fields, user, onSuccess)),
        updateFilteredList: (filteredEquipmentsEPI) => dispatch(updateFilteredList(filteredEquipmentsEPI)),
    };
};

export default compose(withRouter, withStyles(styles), connect(mapStateToProps, mapDispatchToProps))(EquipmentEPI);
